import React, { useEffect } from 'react'
import * as classes from './Contacts.module.scss'
import Container from '../../ui/Container/Container'
import Info from './Info/Info'
import Form from './Form/Form'
import { content } from './content'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function Contacts({ data, lang }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            gsap.utils.toArray('.contacts-separator').forEach((el) => {
                gsap.to(el, {
                    duration: 1.4,
                    width: '100%',
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 95%'
                    }
                })
            })
        }, 3000)
        return () => clearTimeout(timer)
    }, [])

    return (
        <section className={classes.Section}>
            <Container>
                <Info data={data} lang={lang} />

                <div className={`${classes.Separator} contacts-separator`} />

                <Form data={content.form} dataServer={data} lang={lang} />
            </Container>
        </section>
    )
}

export default Contacts
